import React, { useState } from "react";
import axios from "axios";
import { config } from "../../config";

const apiUrl = config.apiUrl;

const CreateTestimonial = ({ onTestimonialCreated }) => {
  const [formData, setFormData] = useState({
    name: "",
    feedback: "",
    rating: "",
    image: null,
  });

  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("name", formData.name);
    data.append("feedback", formData.feedback);
    data.append("rating", formData.rating);
    if (formData.image) {
      data.append("image", formData.image);
    }

    try {
      await axios.post(`${apiUrl}/testimonials`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Testimonial Created Successfully!");
      onTestimonialCreated();
    } catch (err) {

      console.log(err?.response?.data?.message)
      setError("An error occurred while creating the testimonial.");
    }
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Testimonial</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit}>
        {/* Name */}
        <div className="mb-4">
          <label className="block text-gray-700">Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>

        {/* Feedback */}
        <div className="mb-4">
          <label className="block text-gray-700">Feedback</label>
          <textarea
            name="feedback"
            value={formData.feedback}
            onChange={handleChange}
            className="border w-full p-2"
            required
          ></textarea>
        </div>

        {/* Rating */}
        <div className="mb-4">
          <label className="block text-gray-700">Rating (0-5)</label>
          <input
            type="number"
            name="rating"
            value={formData.rating}
            onChange={handleChange}
            className="border w-full p-2"
            min="0"
            max="5"
            step="0.1"
            required
          />
        </div>

        {/* Image */}
        <div className="mb-4">
          <label className="block text-gray-700">Image</label>
          <input
            type="file"
            name="image"
            onChange={handleChange}
            className="border w-full p-2"
            accept="image/*"
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Create Testimonial
        </button>
      </form>
    </div>
  );
};

export default CreateTestimonial;
